import Typewriter from 'typewriter-effect'
import { useWaitTypewriter } from '../../../hooks/useWaitTypewriter'

const MedalistsTitle = ({ title, brief }: any) => {
  const { itemHasAppeared, ref } = useWaitTypewriter()
  return (
    <div className='flex flex-col items-center mb-[50px] md:mb-[105px] lg:mb-[100px] px-[25px] lg:px[0px]'>
      <h2 ref={ref} className='text-[25px] font-extrabold leading-[80%] tracking-[0] text-center md:text-[53.05px] md:font-[800] md:leading-[80%] md:tracking-[0] md:text-center md:uppercase font-abcd lg:text-[60px] lg:leading-[100%] lg:tracking-[-0.05em] align-bottom uppercase lg:whitespace-pre-line max-w-[400px] md:max-w-[600px] lg:max-w-[100%]'>
        {itemHasAppeared && <Typewriter
          onInit={(typewriter) => {
            typewriter.typeString(title).start()
          }}
        />}
      </h2>
      <p className='text-[16px] font-normal leading-[100%] tracking-[-0.05em] text-center font-swinton max-w-4xl md:text-[40.32px] md:font-[400] md:leading-[100%] md:tracking-[-0.05em] md:text-center lg:text-[16px] lg:font-[400] lg:leading-[100%] lg:tracking-[-0.05em] lg:text-center lg:whitespace-pre-line'>
        {brief}
      </p>
    </div>
  )
}

export default MedalistsTitle
